import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import ChainedBackend from 'i18next-chained-backend';
import HttpBackend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

const defaultLocale = 'en_GB';
const languageSeparator = /[_-]/;

export const availableLocales = [
    ['ca_ES', 'Català Valenciana'],
    ['cs', 'Čeština'],
    ['de', 'Deutsch'],
    ['en_GB', 'English (UK)'],
    ['en_US', 'English (US)'],
    ['es_ES', 'Español'],
    ['fr_CA', 'Français (Canada)'],
    ['fr_FR', 'Français (France)'],
    ['he_IL', 'עברית'],
    ['it', 'Italiano'],
    ['nl_NL', 'Nederlands'],
    ['pt_PT', 'Português'],
    ['ru', 'Русский'],
];

const fallbackLocales: { [key: string]: string } = {
    ca: 'ca_ES', // Catalan
    cs: 'cs', // Czech Czech Republic
    de: 'de', // German Germany
    en: 'en_GB', // English
    es: 'es_ES', // Spanish
    fr: 'fr_FR', // French
    he: 'he_IL', // Hebrew
    it: 'it', // Italian Italy
    nl: 'nl_NL', // Dutch
    pt: 'pt_PT', // Portuguese
    ru: 'ru', // Russian Russia
};

export const getLocale = (lng?: string | string[]) => {
    const language = (Array.isArray(lng) ? lng[0] : lng) ?? i18n.language;

    return Object.values(fallbackLocales).includes(language)
        ? language
        : fallbackLocales[getRoot(language)] ?? defaultLocale;
};
export const getShortLocale = (lng?: string | string[]) => getRoot(getLocale(lng)); // For example, 'ca_ES' will return 'ca'
export const getLocaleRegion = (lng?: string | string[]) => {
    const language = getLocale(lng);
    return languageSeparator.test(language) ? language.split(languageSeparator)[1] : language.toLowerCase();
}; // For example, 'ca_ES' will return 'ES'
const getRoot = (lng: string) => lng?.split(languageSeparator)[0].toLowerCase();

i18n.use(ChainedBackend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: defaultLocale, // use en_GB if detected lng is not available
        keySeparator: false,
        interpolation: {
            escapeValue: false,
        },
        react: {
            nsMode: 'default',
        },
        backend: {
            backends: [HttpBackend],
            backendOptions: [
                {
                    loadPath: (lng: string | string[]) =>
                        `${import.meta.env.VITE_PUBLIC_TRANSLATION_DOMAIN}/${getLocale(lng)}.json`,
                },
            ],
        },
    });

export default i18n;
